module.exports = __webpack_public_path__ + "4f83b99e31761500474ddbe611b77fcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/list/wenquan/second-title.png
// module id = 1183
// module chunks = 0